module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/ant-mobile.2d1a29f0.png";